import { authAction as auth } from "./auth";
import { globalAction as global } from "./global";

export default {
  auth,
  global
};
